module.exports = __webpack_public_path__ + "images/d8537274a001dd971ab2568bb73fe758.png";